window.$ = window.jQuery;

require("./modules/header-navigation");
require("./modules/header-language");
require("./modules/header-location");
require("./modules/tabs");
// require("./modules/gform-misc.js");
require("./modules/family-table");
require("./modules/accordion");
require("./modules/select");
require("./modules/table");
require("./modules/matchheight");
require("./modules/advanced-search-results");
require("./modules/part-search-results");
require("./modules/contact-page");
require("./modules/homepage");
require("./modules/cap-landing");
require("./modules/find-sales");
require("./modules/tooling-table");
require("./modules/contacts-table");
require("./modules/pcn-table");
require("./modules/tech-specs-table");
require("./modules/intranet");
require("./modules/browse-by-image");
require("./modules/country-code-phone");
require("./modules/channel-partners");
require("./modules/traceparts");
require("./modules/add-to-homescreen");
require("./modules/qpl-search-results");
require("./utils/misc");

// TODO break these out
require("./create-a-part/index.js");
require("./training.js");
